import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { fetch, setDadosPesq } from "../actions";
import SelectBasico from "./SelectBasico";
import { SubTitulo } from "./Diversos";
import { usePesq } from './Hooks/Pesq';

function Func(props) {
  const modelo = 'fabricante';
  const [, loading] = usePesq(props.fetch, props.pesq, props.setDadosPesq, modelo);

  if (!props.pesq[modelo] || props.pesq[modelo].length == 1) {
    return null;
  }

  return (
    <div style={props.style}>
      {props.title && <SubTitulo>{props.title}</SubTitulo>}
      <SelectBasico {...props} placeholder="Fabricantes" dados={props.pesq[modelo] || []} loading={loading} />
    </div>
  );
}

const mapStateToProps = state => {
  return { pesq: state.pesq };
};

export default connect(mapStateToProps, { fetch, setDadosPesq })(Func);
